const ApiUrl = `${process.env.VUE_APP_API_PP_PARTIDOS}`

import axios from '@/interceptor-core'

export const requestReclamacionMixin = {
  methods: {
    crearReclamacion(body) {
      return axios.post(`${ApiUrl}/reclamacion/crear`, body);
    },
    getReclamacionEstado() {
      return axios.post(`${ApiUrl}/reclamacion/estado`);
    },
  }
};
